import { Route, Routes } from "react-router-dom";

import Kalmainhome from "./components/KalHome/Kalmainhome";
import Maincontact from "./components/Contactus/Maincontact";
import Login from "./components/SIgnin/Login";
import Register from "./components/SIgnin/Register";
import MainCheckout from "./components/Checkoutpage/MainCheckout";

import Addtocart from "./components/Addtocart/Addtocart";
import Wishlist from "./components/Addtocart/Wishlist";

import TermsAndConditionsPage from "./components/Privacy/Termsandconditions";
import Privacypolicy from "./components/Privacy/Privacypolicy";
import Faq from "./components/Privacy/Faq";
import Trackyourorder from "./components/Trackyourorder/Trackyourorder";
import Descriptionpreview from "./components/Descriptionpreview/Descriptionpreview";
import Wishlistdescription from "./components/Wishlistdescription/Wishlistdescription";
import CategoryProducts from "./components/ProductsNew/CategoryProducts";
import SeeAllSubcategory from "./components/ProductsNew/SeeAllSubcategory";
import { BackTop } from "antd";
import BackToTop from "./components/BackToTop/BackToTop";
import ProfilePage from "./components/ProfilePage/ProfilePage";

export default function Routers() {
  return (
    <>
      <Routes>
        <Route exact path="/" element={<Kalmainhome />} />
        <Route exact path="/:CategoryID" element={<CategoryProducts />} />
        <Route path="/seeall/:subCategoryId" element={<SeeAllSubcategory />} />
        <Route path="/product/:ProductId" element={<Descriptionpreview />} />
        <Route exact path="/contactus" element={<Maincontact />} />

        <Route exact path="/login" element={<Login />} />
        <Route exact path="/register" element={<Register />} />

        <Route exact path="/checkout" element={<MainCheckout />} />

        <Route exact path="/myProfile" element={<ProfilePage />} />

        <Route exact path="/MyProfile/Addtocart" element={<Addtocart />} />
        <Route exact path="/MyProfile/Wishlist" element={<Wishlist />} />

        <Route
          exact
          path="/Terms/Conditions"
          element={<TermsAndConditionsPage />}
        />
        <Route exact path="/Privacy/Policy" element={<Privacypolicy />} />

        <Route exact path="/Faq/faq" element={<Faq />} />

        <Route
          exact
          path="/TrackYourOrder/myOrders"
          element={<Trackyourorder />}
        />

        <Route
          exact
          path="/Descriptionpreview/Descriptionpreview"
          element={<Descriptionpreview />}
        />

        <Route
          exact
          path="/Wishlistdescription/Wishlistdescription"
          element={<Wishlistdescription />}
        />
        
      </Routes>

      <BackToTop />
    </>
  );
}
